import { gql } from 'graphql-request'
import { ItemPastaFragment } from './item-pasta-fragment'

export const ALTERAR_PROPRIETARIO = gql`
  mutation AlterarProprietarioMutation(
    $alterarProprietarioInput: AlterarProprietarioInput!
  ) {
    alterarProprietario(alterarProprietarioInput: $alterarProprietarioInput) {
      ...ItemPastaFragment
    }
  }
  ${ItemPastaFragment}
`
